import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { WorksheetTab } from "@/features/worksheets/types";

const TABS: { key: WorksheetTab; label: string }[] = [
  { key: "personal", label: "Personal & Employment" },
  { key: "financial", label: "Financial Circumstances" },
  { key: "assets", label: "Assets" },
  { key: "banking", label: "Banking & Investments" },
  { key: "incexp", label: "Income & Expenses" },
  { key: "offer", label: "Offer / IA Summary" },
];

/** Tab strip for the worksheet sub-pages under a case. */
export function WorksheetTabs({ clientId, caseId }: { clientId: string; caseId: string }) {
  return (
    <nav className="border-border flex flex-wrap gap-1 border-b" aria-label="Worksheet sections">
      {TABS.map((t) => (
        <NavLink
          key={t.key}
          to={`/client/${clientId}/cases/${caseId}/worksheets/${t.key}`}
          className={({ isActive }) =>
            cn(
              "border-b-2 px-3 py-2 text-sm font-medium transition-colors",
              isActive
                ? "border-primary text-primary"
                : "text-muted-foreground hover:text-foreground border-transparent",
            )
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
